export default {
  android: 'Biometric',
  ios: 'Biometric or Passcode',
  none: '-',
};
